import React from 'react';
import { Modal, DatePicker } from 'antd';
import styled from 'styled-components';

const { RangePicker } = DatePicker;
const StyledLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

class DateRangeModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedDates: null,
      applyBtnDisabled: true,
    };

    this.disabledDate = this.disabledDate.bind(this);
    this.updateSelectedDate = this.updateSelectedDate.bind(this);
    this.handleOK = this.handleOK.bind(this);
  }

  handleOK() {
    console.log('########## selectedDates: ',this.state.selectedDates);
    this.props.addDateRangeToWhere(this.state.selectedDates);
    this.props.setDateModalVisible(false)
  }

  updateSelectedDate(dates, dateStrings) {
    console.log('######## in updateSelectedDate: ',dateStrings);
    if(dateStrings[0] == "" || dateStrings[1] == "") {
      this.setState({
        selectedDates: dateStrings,
        applyBtnDisabled: true,
      });
    } else {
      this.setState({
        selectedDates: dateStrings,
        applyBtnDisabled: false,
      });
    }
  }

  disabledDate(current) {
    const today = new Date();
    const start = (new Date()).setMonth(today.getMonth() - 3);
    return !current || current > today || current < start;
  };

  render() {
    const dateFormat = 'YYYY-MM-DD';
    return ( <Modal
      title="Add date range to the 'Where' clause"
      centered
      visible={this.props.dateModalVisible}
      onOk={this.handleOK}
      okText={'Add'}
      onCancel={() => this.props.setDateModalVisible(false)}
      width={380}
      okButtonProps={{'disabled': this.state.applyBtnDisabled}}
    >
      <StyledLabel>Choose date range</StyledLabel>
      <RangePicker
        format={dateFormat}
        onChange={this.updateSelectedDate}
        disabledDate={this.disabledDate}
      />
    </Modal>);
  }
}

export default DateRangeModal;